// React
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
// Components
import ShowPhoneButton from './ShowPhoneButton'
import dialogsManagerActions from '../../redux/actions/dialogsManager.actions'

const mapStateToProps = (state, { intl: { formatMessage } }) => {
  const showPhoneText = formatMessage({
    id: 'showPhoneButton.label',
  })

  return { showPhoneText }
}
const mapDispatchToProps = {
  onClick: dialogsManagerActions.openCustomerPhoneProxySessionDialog,
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ShowPhoneButton),
)
